/**
 * 贪吃猫狗：规则事件 → 动作段（B，pet_arcade/core；合同 PET-ARCADE-SNAKE-RULES-B-2026-10-01.md §3a，
 * 段名对 I 的动作清单 F0 docs/coordination/MOTION-MANIFEST-F0-I-2026-10-01.md 第 4 节）。纯函数，UI 播放器与用例共用一张表。
 *
 * 口径：规则在事件那一步判定，播放器在那一帧切段，不等动画播完。段里的 step／bite／impact／pose 是动画自带的帧标记
 * （播放器 → UI 的音效、粒子），不是规则事件，这里不产生。
 */

import type { SnakeEventBody } from "./snake";

export type SnakeMoveClip = "move_up" | "move_down" | "move_left" | "move_right";
export type SnakeClip = SnakeMoveClip | "eat" | "blocked" | "hit" | "end_win" | "end_lose";

/** 朝向（弧度，atan2(vy, vx)，屏幕 y 向下）→ 走动段；正好在对角线上时取左右。 */
export function moveClipOf(facing: number): SnakeMoveClip {
  const dx = Math.cos(facing);
  const dy = Math.sin(facing);
  if (Math.abs(dx) >= Math.abs(dy) - 1e-9) return dx >= 0 ? "move_right" : "move_left";
  return dy > 0 ? "move_down" : "move_up";
}

/**
 * 一条规则事件要切到哪一段；null＝不切段（UI 自己做特效，或维持当前段）。
 * - hit 单出一段（P 定：被撞扣一条命，要和撞墙不扣命的 blocked 分得清）；fixture 期借不借 blocked 的帧归 UI，这里只给段名；
 * - size_changed 用缩放表现，crate_broken、near_miss 是特效；quit 直接离开、不播结尾段。
 */
export function clipForEvent(event: SnakeEventBody): SnakeClip | null { // 带不带标识都收
  switch (event.type) {
    case "ate":
      return "eat";
    case "blocked":
      return "blocked";
    case "hit":
      return "hit";
    case "ended":
      if (event.reason === "time_up") return "end_win";
      if (event.reason === "out_of_hearts") return "end_lose";
      return null;
    default:
      return null;
  }
}
